import type { ProductAttribute, ProductAttributeFormState } from '@@partner:types:app'

import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'

export const PRODUCT_GROUP_DEFAULT_STATE: ProductAttributeFormState = {
  id: undefined,
  name: '',
  value_type: 'string',
  is_filterable: false,
  is_searchable: false,
  prefix: '',
  postfix: '',
  slug: '',
  xname: '',
  filter_name: ''
}

export const makeProductAttributeFormState = (productAttribute?: ProductAttribute): ProductAttributeFormState => {
  return mergeLeft<ProductAttributeFormState>(PRODUCT_GROUP_DEFAULT_STATE, productAttribute)
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (state: ProductAttributeFormState): any =>
  mergeLeftDropping([], PRODUCT_GROUP_DEFAULT_STATE, {
    ...state
  })

export const mapApiDataToState = (data: ProductAttribute) => makeProductAttributeFormState(data)
